import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyHotelBookingApp = loadable(() => import(/* webpackChunkName: "content/hotel/booking" */ './HotelBooking'), 'HotelBookingApp');
